import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { editSpecialDay } from '../../../../redux/shifts/shiftsActions'
import { useTypedSelector } from '../../../../redux/store'
import { EditSpecialDayForm } from '../../../containers'
import { SpecialDay, SpecialDayFormData } from '../../../entities/SpecialDay/SpecialDay'

export interface ConnectedEditSpecialDayFormProps {
    specialDay: SpecialDay;
    year: number;
    onClose: () => void;
}

export const ConnectedEditSpecialDayForm: FC<ConnectedEditSpecialDayFormProps> = ({ specialDay, year, onClose }) => {
    const specialDayTypes = useTypedSelector((state) => state.shiftsReducer.specialDayTypes)

    const dispatch = useDispatch()

    const dispatchEditSpecialDay = (data: SpecialDayFormData) => {
        dispatch(editSpecialDay(data, year))
        onClose()
    }

    return (
        <EditSpecialDayForm
            onSubmit={dispatchEditSpecialDay}
            onCancel={onClose}
            specialDay={specialDay}
            specialDayTypes={specialDayTypes}
        />
    )
}
